<template>
  <div>
    <!-- <div v-if="hasMta"> -->
    <div v-if="hasUser">
      <div class="columns pb-2">
        <div class="text__error">{{ getCaption("caption.card_register.note.title") }}</div>
        <div class="column text-justify" v-html="getCaption('caption.card_register.note.body')"></div>
      </div>

      <div class="d-flex justify-content-center my-2">
        <div class="col-xs-11 col-sm-10 col-md-8 col-6">
          <div class="form-horizontal">
            <div class="form-group">
              <div class="col-3 col-sm-12">
                <strong>
                  <label
                    class="form-label"
                    for="input-example-1"
                  >{{ getCaption("caption.card_name") }}</label>
                </strong>
              </div>
              <div class="col-9 col-sm-12">
                <input
                  class="form-input rounded text-center focus-purple"
                  type="text"
                  :placeholder="getCaption('caption.card_name')"
                  v-on:input="onChangeHandler('name', $v.name)"
                  :class="{ 'is-error': $v.name.$error }"
                  v-model="name"
                >
                <span
                  v-if="!$v.name.serverFailed"
                  class="error-msg__data"
                >{{ this.getErrorMsg('name')[0] }}</span>
              </div>
            </div>
          </div>
          <div class="form-horizontal">
            <div class="form-group">
              <div class="col-3 col-sm-12">
                <strong>
                  <label
                    class="form-label"
                    for="input-example-1"
                  >{{ getCaption("caption.card_number") }}</label>
                </strong>
              </div>
              <div class="col-9 col-sm-12">
                <div class="columns">
                  <div class="pr-1 col-1 h5 flex-centered">16</div>
                  <div class="pl-1 pr-1 col-2">
                    <input
                      class="form-input rounded text-center focus-purple"
                      type="text"
                      maxlength="2"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      v-on:input="onChangeHandler('number', $v.number); toNext($event, $refs.input2)"
                      :class="{ 'is-error': $v.number.$error }"
                      v-model="number.number1"
                    >
                  </div>
                  <div class="pl-1 pr-1 col-3">
                    <input
                      class="form-input rounded text-center focus-purple"
                      type="text"
                      maxlength="4"
                      ref="input2"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      v-on:input="onChangeHandler('number', $v.number); toNext($event, $refs.input3)"
                      :class="{ 'is-error': $v.number.$error }"
                      v-model="number.number2"
                    >
                  </div>
                  <div class="pl-1 pr-1 col-3">
                    <input
                      class="form-input rounded text-center focus-purple"
                      type="text"
                      maxlength="4"
                      ref="input3"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      v-on:input="onChangeHandler('number', $v.number); toNext($event, $refs.input4)"
                      :class="{ 'is-error': $v.number.$error }"
                      v-model="number.number3"
                    >
                  </div>
                  <div class="pl-1 col-3">
                    <input
                      class="form-input rounded text-center focus-purple"
                      type="text"
                      maxlength="4"
                      ref="input4"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      v-on:input="onChangeHandler('number', $v.number)"
                      :class="{ 'is-error': $v.number.$error }"
                      v-model="number.number4"
                    >
                  </div>
                </div>
                <span
                  v-if="!$v.number.serverFailed"
                  class="error-msg__data"
                >{{ this.getErrorMsg('number')[0] }}</span>
              </div>
            </div>
          </div>
          <div class="form-group" style="padding: .4rem 0;">
            <button
              @click="onSubmit"
              type="button"
              class="btn btn--color-purple btn--width-full rounded"
              click="onSubmit"
            >
              <div v-if="submitStatus === 'PENDING'" class="loader--sm"></div>
              <span v-else>{{ this.getCaption("caption.card_register") }}</span>
            </button>
          </div>
        </div>
      </div>
      <div v-if="cardList.length > 0" class="d-flex justify-content-center mt-2 pt-2">
        <div class="col-xs-11 col-sm-11 col-md-11 col-lg-11 col-xl-10 col-9">
          <div class="card">
            <div class="size-4 p-2 mb-2">{{ getCaption("caption.cards") }}</div>
            <table class="table table-responsive table-striped">
              <thead>
                <tr>
                  <th>№</th>
                  <th>{{ getCaption("caption.card_name") }}</th>
                  <th>{{ getCaption("caption.card_number") }}</th>
                  <th>{{ getCaption("caption.card_register_date") }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <router-link
                  tag="tr"
                  class="c-hand"
                  v-for="(card, i) in cardList"
                  :key="`card${i}`"
                  :to="{path: '/m/card-detail', query: {cardId: card.id}}"
                >
                  <td class="table__key">
                    <div class="table__cell--label">№</div>
                    <div class="table__cell--content">{{ i + 1 }}</div>
                  </td>
                  <td class="table__key">
                    <div class="table__cell--label">{{ getCaption("caption.card_name") }}</div>
                    <div class="table__cell--content">{{ card.name }}</div>
                  </td>
                  <td>
                    <div class="table__cell--label">{{ getCaption("caption.card_number") }}</div>
                    <div class="table__cell--content">{{ formatString(card.number, [4,8,12], " ") }}</div>
                  </td>
                  <td>
                    <div class="table__cell--label">{{ getCaption("caption.card_register_date") }}</div>
                    <div class="table__cell--content">{{ card.created }}</div>
                  </td>
                  <td class="table__actions">
                    <button
                      @click.stop="editCardClick(card)"
                      class="btn btn-primary btn-sm mx-2"
                    >{{ getCaption("caption.edit_card") }}</button>
                    <button
                      v-on:click.stop="confirmDelete(card)"
                      class="btn btn-error btn-sm"
                    >{{ getCaption("caption.delete_card") }}</button>
                  </td>
                </router-link>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-else class="text-center mt-2 pt-2">
        <span class="chip size-3 p-2">{{ getCaption("caption.empty_result") }}</span>
      </div>
    </div>

    <!-- <div v-else class="d-flex justify-content-center">
      <div class="col-xs-11 col-sm-10 col-md-6 col-4">
        <div class="toast toast-error my-2">{{ getCaption("caption.mta_check_description") }}</div>
        <div class="form-group">
          <button
            type="button"
            class="btn btn--color-purple btn--width-full rounded"
            @click="checkMta()"
          >
            <div v-if="mtaCheckStatus === 'PENDING'" class="loader--sm"></div>
            <span v-else>{{ this.getCaption("caption.mta_check_button") }}</span>
          </button>
        </div>
      </div>
    </div> -->

    <div class="u-modal" :class="{ 'active': showModal }">
      <div class="u-modal__background"></div>
      <div class="u-modal__container">
        <div class="u-modal__header">
          <!-- <div class="u-modal__title">Modal title</div> -->
          <div @click="showModal=false" class="u-modal__close">
            <i class="fas fa-times"></i>
          </div>
        </div>
        <div class="u-modal__body">
          <strong>{{ selectedCard != null ? formatString(selectedCard.number, [4,8,12], " ") : "" }}</strong>
          {{ getCaption("caption.confirm_delete_card") }}
        </div>
        <div class="u-modal__footer">
          <div
            class="u-modal__actionBtn"
            @click="deleteCard()"
          >{{ getCaption("caption.yes_button") }}</div>
          <div
            class="u-modal__actionBtn"
            @click="showModal=false"
          >{{ getCaption("caption.no_button") }}</div>
        </div>
      </div>
    </div>
    <card-edit-modal ref="cardEditModal"/>
  </div>
</template>

<script>
import { myCards } from "@/constants/sidemenu.js";
import OtherService from "@/services/OtherService.js";
import CardService from "@/services/CardService.js";
import UserService from "@/services/UserService";
import Form from "@/mixins/Form.js";
import { required } from "vuelidate/lib/validators";
import CardEditModal from "@/components/card/CardEditModal";

export default {
  mixins: [Form],

  components: {
    CardEditModal
  },

  data() {
    return {
      cardList: [],
      name: "",
      number: {
        number1: "",
        number2: "",
        number3: "",
        number4: ""
      },

      showModal: false,
      selectedCard: null,
      mtaCheckStatus: null
    };
  },

  computed: {
    hasMta: function() {
      return (
        this.$store.state.loggedUser &&
        this.$store.state.loggedUser.mtaAccount != null
      );
    },
    hasUser: function() {
      return (
        this.$store.state.loggedUser
      );
    },
    currentPath() {
      return this.$router.currentRoute.path;
    }
  },

  watch: {
    hasMta: function(val) {
      if (val) this.getCardList();
    }
  },

  validations: {
    name: {
      required,
      serverFailed: function() {
        return !this.hasServerError("name");
      }
    },
    number: {
      number1: {
        required
      },
      number2: {
        required
      },
      number3: {
        required
      },
      number4: {
        required
      },
      serverFailed: function() {
        return !this.hasServerError("number");
      }
    }
  },

  created() {
    if (!this.isAuth()) {
      this.$router.replace({ name: "SignIn" });
    }
  },

  mounted() {
    if (this.hasUser) this.getCardList();
  },

  methods: {
    checkMta() {
      this.mtaCheckStatus = "PENDING";
      OtherService.checkMta()
        .then(response => {
          this.showToast(this.getCaption(response.data.payload.toast), true);
          UserService.userInfo().then(response => {
            this.$store.dispatch("setUser", response.data.payload);
            this.mtaCheckStatus = "";
          });
        })
        .catch(error => {
          this.mtaCheckStatus = "";
        });
    },

    serverRequest: CardService.registerCard,

    successHandler() {
      this.name = "";
      this.number.number1 = "";
      this.number.number2 = "";
      this.number.number3 = "";
      this.number.number4 = "";
      this.$v.$reset();
      this.getCardList();
    },

    createJsonData() {
      const data = JSON.parse("{}");
      data.name = this.name;
      data.number =
        this.number.number1 +
        this.number.number2 +
        this.number.number3 +
        this.number.number4;
      return data;
    },

    getCardList() {
      CardService.getCardList().then(response => {
        if (response.status == 200 && response.data.success == true) {
          this.cardList = response.data.payload;
        }
      });
    },

    editCardClick(card) {
      this.$refs.cardEditModal.init(card);
    },

    confirmDelete(card) {
      this.selectedCard = card;
      this.showModal = true;
    },

    deleteCard() {
      this.showModal = false;
      const data = JSON.parse("{}");
      data.id = this.selectedCard.id;
      CardService.deleteCard(data)
        .then(response => {
          if (response.status == 200 && response.data.success == true) {
            this.showToast(this.getCaption(response.data.payload.toast), true);
            let index = this.cardList
              .map(card => card.id)
              .indexOf(this.selectedCard.id);
            if (index > -1) this.cardList.splice(index, 1);
          }
        })
        .catch(error => {
          if (error.response.data.payload.errors[0].name === "fatal") {
            this.showToast(
              this.getCaption(error.response.data.payload.errors[0].message),
              false
            );
            this.getCardList();
          }
        });
    },

    formatString(str, indexArray, char) {
      for (var i = 0; i < indexArray.length; i++) {
        str =
          str.slice(0, indexArray[i] + i) + char + str.slice(indexArray[i] + i);
      }
      return str;
    },

    toNext(event, next) {
      if (
        event.target.value.length ==
        parseInt(event.target.getAttribute("maxlength"))
      )
        next.focus();
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  border: none;
}

.card + .card {
  margin-top: 2em;
}

.table__cell--content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  margin: 0 auto;
}

@media (min-width: 740px) {
  thead {
    display: table-header-group;
  }

  tr {
    display: table-row;
  }

  tbody > tr:hover {
    background-color: #f2f2f2 !important;
  }

  td {
    text-align: left;
  }

  .table__key {
    width: auto;
    .table__cell--content {
      font-size: 1em;
    }
  }

  .table__cell--content {
    margin: 0;
  }

  .table__cell--label {
    display: none;
  }

  .table__actions {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
